module.exports = __webpack_public_path__ + "static/media/proton-go-drive.00ecd2c1.png";